import 'mapbox-gl/dist/mapbox-gl.css'
import mapboxgl from 'mapbox-gl'

import { Map, LngLatBoundsLike, LngLatLike } from 'mapbox-gl'

import { useEffect, useState } from 'react'

import { useMapStore } from '@monopolio-ui/state-library'
import { usePolygons } from '../hooks/usePolygons'

const MAPBOX_STYLE = process.env.MAPBOX_STYLE ?? ''
const MAPBOX_API_KEY = process.env.MAPBOX_API_KEY ?? ''

const defaultCenter = {
  lng: -99.1394,
  lat: 19.2769,
}

export interface MapboxInstance {
  id: string
  children?: React.ReactNode
  className?: string
  zoom?: number
  center?: {
    lng: number
    lat: number
  }
}

const MapboxInstance = ({
  id,
  children = null,
  className,
  zoom = 10,
  center
}: MapboxInstance) => {
  usePolygons()
  const { map, isLoadedMap, setMap, setIsLoadedMap, setMapZoom } = useMapStore()
  
  const getCenter = (): LngLatLike => {
    if (center) {
      return {
        lat: center?.lat,
        lng: center?.lng,
      }
    }
    return {
      lat: defaultCenter?.lat,
      lng: defaultCenter?.lng,
    }
  }
  
  const [bounds] = useState<LngLatBoundsLike>([
    [-119.12776, 10.5388286402],
    [-86.516792, 32.722436],
  ])

  useEffect(() => {
    if (map) {
      return
    }
    const instance = new Map({
      style: MAPBOX_STYLE,
      container: id,
      center: getCenter(),
      zoom,
      maxBounds: bounds,
      maxPitch: 65,
      maxZoom: 22,
      accessToken: MAPBOX_API_KEY,
    })
    instance.addControl(
      new mapboxgl.NavigationControl({
        showCompass: false,
      }),
      'bottom-right'
    )
    setMap?.(instance)
  }, [bounds, id, map])

  useEffect(() => {
    map?.on('load', () => {
      if (map.isStyleLoaded() && !isLoadedMap) {
        setIsLoadedMap(true)
      }
    })
  })

  useEffect(() => {
    const onZoom = (): void => {
      setMapZoom(map?.getZoom() || 0)
    }

    map?.on('zoom', onZoom)

    return () => {
      map?.off('zoom', onZoom)
    }
  }, [map])

  return (
    <div className="w-full h-full">
      <div id={id} className={['w-full h-full', className ?? ''].join(' ')} />
      {children}
    </div>
  )
}

export default MapboxInstance
